// extracted by mini-css-extract-plugin
module.exports = {"d2xDetail":"detail_us_d2xDetail__6tHVY"};